module.exports = __webpack_public_path__ + "static/img/06ko.e85a439.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/06ko.jpg
// module id = jcJP
// module chunks = 0